// frontend/src/components/admin/modals/BanUserModal.jsx
import React, { useState } from 'react';
import axios from '../../../config/axios';

const BanUserModal = ({ user, onClose, onSuccess }) => {
    const [banType, setBanType] = useState('temporary');
    const [duration, setDuration] = useState('24');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('/admin/users/toggle-ban', {
                userId: user.id,
                permanent: banType === 'permanent',
                banDuration: banType === 'permanent' ? null : duration * 60 * 60 * 1000 // Convertir horas a milisegundos
            });

            if (response.data.success) {
                onSuccess(response.data.user);
                onClose();
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Error al banear usuario');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold text-primary mb-4">
                    Banear a {user.username}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                            Tipo de Ban
                        </label>
                        <div className="space-y-2">
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    id="temporary"
                                    value="temporary"
                                    checked={banType === 'temporary'}
                                    onChange={(e) => setBanType(e.target.value)}
                                    className="mr-2"
                                />
                                <label htmlFor="temporary">Temporal</label>
                            </div>
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    id="permanent"
                                    value="permanent"
                                    checked={banType === 'permanent'}
                                    onChange={(e) => setBanType(e.target.value)}
                                    className="mr-2"
                                />
                                <label htmlFor="permanent">Permanente</label>
                            </div>
                        </div>
                    </div>

                    {banType === 'temporary' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Duración (horas)
                            </label>
                            <input
                                type="number"
                                min="1"
                                value={duration}
                                onChange={(e) => setDuration(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                                required
                            />
                        </div>
                    )}

                    {error && (
                        <p className="text-red-500 text-sm">{error}</p>
                    )}

                    <div className="flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
                        >
                            {loading ? 'Procesando...' : 'Banear Usuario'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BanUserModal;